import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LogController from "../controller/LogController";
import { langState, langText } from "../recoil/lang";
import { useRecoilValue } from "recoil";

interface BackButtonProps {
  pathname?: string;
}

export function BackButton({ pathname }: BackButtonProps) {
  const lang = useRecoilValue(langState);
  const navigate = useNavigate();

  function navigateMaster() {
    if (pathname) {
      LogController.click({
        path: pathname,
        params: "click",
        params2: "홈버튼 클릭",
      });
    }
    navigate(`/master`);
  }

  return (
    <Style onClick={navigateMaster}>
      <img
        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
        alt="back"
      />
      <h3>{langText.back[lang]}</h3>
    </Style>
  );
}

const Style = styled.button`
  display: flex;
  align-items: center;
  border: 1px solid #555555;
  background: #262626;
  border-radius: 50px;
  padding: 2px 20px 2px 6px;

  img {
    width: 32px;
    height: 32px;
  }
`;
